import { render, staticRenderFns } from "./UpDown.vue?vue&type=template&id=6c92407e&"
import script from "./UpDown.vue?vue&type=script&lang=js&"
export * from "./UpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports